import React from 'react';
import { Box } from '@mui/material';
import { FormTitle } from '@/components/form-elements/components';

type Store = {
  badge: string;
  badgeAlt: string;
  qr: string;
  qrAlt: string;
};

const STORES: Store[] = [
  {
    badge: '/static/images/app-store-badge.png',
    badgeAlt: 'Download on the App Store',
    qr: '/static/images/qr-app-store.png',
    qrAlt: 'App Store QR Code',
  },
  {
    badge: '/static/images/google-play-badge.png',
    badgeAlt: 'Get it on Google Play',
    qr: '/static/images/qr-google-play.png',
    qrAlt: 'Google Play QR Code',
  },
];

const QRCode: React.FC = () => {
  return (
    <Box width="100%">
      <FormTitle>Mobile Apps</FormTitle>
      <Box
        display="flex"
        width="100%"
        justifyContent="center"
        alignItems="flex-start"
        flexWrap="wrap"
        gap={4}
      >
        {STORES.map((store) => (
          <Box
            key={store.badge}
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={1.5}
          >
            <img
              height={50}
              width={150}
              src={store.badge}
              alt={store.badgeAlt}
            />
            <img height={150} width={150} src={store.qr} alt={store.qrAlt} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default QRCode;
